import { SelfService } from "@/models/SelfService";
import { axiosInstance } from "./axiosInstance";

export const createSelfService = async (
  data: Partial<SelfService>
): Promise<SelfService> => {
  try {
    const response = await axiosInstance.post<SelfService>(
      `/api/selfservice`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
